import { Component, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'app-activity-edition-preview-media',
    templateUrl: './activity-edition-preview-media.component.html',
    styleUrls: ['./activity-edition-preview-media.component.scss'],
    animations: [
        trigger('fadeAndSlideInAndOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(-1.2rem)' }),
                animate('100ms 100ms ease-in-out', style({ opacity: 1, transform: 'translateX(0)' })),
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'translateX(0)' }),
                animate('100ms ease-in-out', style({ opacity: 0, transform: 'translateX(-1.2rem)' })),
            ]),
        ]),
    ],
})
export class ActivityEditionPreviewMediaComponent {
    @Input() media: any;
    @Input() isMediaTypeSelectorActive!: boolean;
    @Input() stepInFocus!: string;
    @Input() currentStepNumber!: number;
}